export default __webpack_public_path__ + "static/media/a2.70c85c31.png";